export const emptyChatFlowObject = {
  id: "",
  botId: "",
  displayName: "",
  botKey: "",
  timeZone: "Europe/Paris",
  language: "",
  dataLocation: "Europe",
  scope: "default",
  attachedFlowId: {
    id: "",
    displayName: ""
  },
  greeting: {
    welcomeMessage: {
      enabled: true,
      text: "Hello, welcome to our chat support by Heedify",
    },
    emergencyMessage: {
      enabled: false,
      text: "",
    },
    flashMessage: {
      enabled: false,
      text: "",
    },
    customMessage: {
      enabled: false,
      text: "",
    },
  },

  deskOpen: {
    holidays: {
      daysOff: [],
      weekendDays: [6, 0],
      holidaysAction: {
        type: "disconnect",
        targetType: "",
        targetId: "",
        queueId: "",
        queueDisplayName: "",
      },
    },
    openHours: {
      0: [{ start: "00:00", end: "23:59" }],
      1: [{ start: "00:00", end: "23:59" }],
      2: [{ start: "00:00", end: "23:59" }],
      3: [{ start: "00:00", end: "23:59" }],
      4: [{ start: "00:00", end: "23:59" }],
      5: [{ start: "00:00", end: "23:59" }],
      6: [{ start: "00:00", end: "23:59" }],
      openHoursAction: {
        type: "disconnect",
        targetType: "",
        targetId: "",
        queueId: "",
        queueDisplayName: "",
      },
    },
  },

  routing: {
    0: {
      type: "Queue",
      customerChoiceName: "",
      customerChoiceText: "",
      queueDisplayName: "",
      queueId: "",
      customerChoiceActions: {},
    },
  },

  password: "",
};
